/**
 * When a Stripe subscription the customer canceled expires, as an ISO string,
 * or null when it is not canceling. Stripe keeps a canceled subscription
 * `active` until then, flagged by `cancel_at_period_end` or a scheduled
 * `cancel_at`. Mirrors `subscriptionCancelAt` in the hub API's utils/mrr.js.
 */
const subscriptionCancelAt = (subscription) => {
  if (!subscription?.cancel_at_period_end && !subscription?.cancel_at) return null;
  // Newer Stripe API versions moved `current_period_end` onto the line items.
  const timestamp = subscription.cancel_at
    || subscription.current_period_end
    || subscription.items?.data?.[0]?.current_period_end;
  return timestamp ? new Date(timestamp * 1000).toISOString() : null;
};

export default subscriptionCancelAt;
